import { useGateValue } from '@statsig/react-bindings';

export const SYNTHETIC_PROVIDERS_GATE = 'synthetic_providers';

/** ZoomLogi Simulator (synthetic courier/sensor) access; the backend enforces it too. */
export function useSyntheticProvidersGate(): boolean {
  return useGateValue(SYNTHETIC_PROVIDERS_GATE);
}
